import React, { useEffect, useRef } from 'react';
import { Box } from '@mui/material';

const styles = {
  wrapper: { height: '70vh', width: '100%' },
  hiddenLink: { display: 'none' },
  mapContainer: { height: '100%', width: '100%' },
};

const BoxNowMap = ({ mapId = 'boxnowmap', config = {}, onSelect }) => {
  const hiddenButtonRef = useRef(null);

  useEffect(() => {
    window._bn_map_widget_config = {
      type: 'iframe',
      gps: true,
      autoselect: true,
      autoclose: false,
      partnerId: 6314,
      parentElement: `#${mapId}`,
      afterSelect: (selected) => {
        if (window.webkit?.messageHandlers?.boxnowLocker) {
          window.webkit.messageHandlers.boxnowLocker.postMessage(selected);
        } else {
          onSelect?.(selected);
        }
      },
      ...config,
    };

    // Load the BoxNow script dynamically
    const script = document.createElement('script');
    script.src = 'https://widget-cdn.boxnow.gr/map-widget/client/v5.js';
    script.async = true;
    script.defer = true;

    script.onload = () => {
      const container = document.getElementById(mapId);

      // if boxnow iframe already exists return
      if (container && container.querySelector('iframe')) {
        return;
      }

      // Once the widget script has loaded, trigger the hidden button click
      // otherwise the widget won't initialize
      if (hiddenButtonRef.current) {
        hiddenButtonRef.current.click();
      }
    };

    document.head.appendChild(script);

    return () => {
      if (document.head.contains(script)) {
        document.head.removeChild(script);
      }
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Box sx={styles.wrapper}>
      <button
        type="button"
        className="boxnow-map-widget-button"
        ref={hiddenButtonRef}
        style={styles.hiddenLink}
        aria-hidden="true"
        tabIndex={-1}
      />
      <Box id={mapId} sx={styles.mapContainer} />
    </Box>
  );
};

export default BoxNowMap;
